function inputValidation(inputFieldValue) {
    if (!inputFieldValue) {
        return '';
    } else if (inputFieldValue.includes("/") || inputFieldValue.includes(":") ||
        inputFieldValue.includes("*") || inputFieldValue.includes("?") || inputFieldValue.includes(",") ||
        inputFieldValue.includes("<") || inputFieldValue.includes(">") ||
        inputFieldValue.includes("|") || inputFieldValue.includes(" ") ||
        inputFieldValue.includes("\"") || inputFieldValue.includes("&") || 
        inputFieldValue.includes("\\") || inputFieldValue.includes("'")) {
        return 'invalid';
    }
    return true;
}

export default inputValidation;